{
  "home": {
    "heroBadge": "英国で信頼されるカードオークションハウス",
    "heroTitleLine1": "英国最大級の",
    "heroTitleLine2": "トレーディングカードマーケット",
    "heroSubtitle": "ポケモン、ワンピース、ガンダム、スポーツカード、Magic: The Gathering、遊戯王、ドラゴンボール超、ディズニー ロルカナなど、鑑定・真贋確認済みのトレーディングカードを、英国全土の安全なライブオークションで売買できます。",
    "browseCta": "ライブオークションを見る",
    "sellCta": "出品を始める",
    "searchPlaceholder": "カード、フィギュア、ファッションなどを検索…",
    "searchButton": "検索",
    "popularLabel": "人気",
    "liveNow": "ライブ配信中",
    "endingTodayCount": "本日終了するオークション {count} 件",
    "highestBid": "最高入札額",
    "endsIn": "終了まで",
    "watchingCount": "{count} 人がウォッチ中",
    "viewLive": "ライブを見る",
    "categoriesEyebrow": "カテゴリーで探す",
    "categoriesTitle": "お気に入りのカードを見つけよう",
    "viewAll": "すべて見る",
    "exploreCta": "見てみる",
    "statCardsListed": "出品中のカード",
    "statCollectors": "コレクター数",
    "statVolume": "オークション取引額",
    "statRating": "出品者評価",
    "statSecurePayments": "安全な決済",
    "statSecurePaymentsDescription": "Stripe による安全な決済処理。",
    "statNoRatingsYet": "評価はまだありません",
    "statNewMarketplace": "新しいマーケットプレイス",
    "statReviewsCount": "{count, plural, other {# 件のレビュー}}",
    "heroBadgeV2": "カード • コレクタブル • ファッション",
    "heroV2Line1": "もっと入札、もっと収集。",
    "heroV2Line2": "BidNovaだけで。",
    "heroV2Subtitle": "トレカ、コレクタブル、ファッションなどを扱う英国のオークションマーケットプレイス。",
    "browseCtaV2": "オークションを見る",
    "sellCtaV2": "出品する",
    "searchPlaceholderV2": "カード、フィギュア、ファッションなどを検索…",
    "categoriesTitleV2": "カード・コレクタブル・ファッション",
    "cat": {
      "cards": "トレカ",
      "graded": "鑑定済みカード",
      "sealed": "未開封商品",
      "collectibles": "フィギュア&コレクタブル",
      "fashion": "ファッション",
      "accessories": "アクセサリー"
    },
    "catBlurb": {
      "cards": "あらゆるゲームのシングル",
      "graded": "PSA・BGS・CGC・ACE など",
      "sealed": "ボックス・パック・缶・デッキ",
      "collectibles": "Funko Pop!・フィギュア・スタチュー",
      "fashion": "ストリートウェア・スニーカー・バッグ",
      "accessories": "スリーブ・ケース・収納"
    },
    "trust": {
      "paymentsTitle": "安全な決済",
      "paymentsSub": "Stripe による決済",
      "shippingTitle": "追跡付き配送",
      "shippingSub": "英国全域",
      "trustedTitle": "信頼のマーケットプレイス",
      "trustedSub": "安心して売買"
    }
  },
  "seo": {
    "trustedMarketplaceEyebrow": "信頼できる英国のマーケットプレイス",
    "introTitle": "世界で人気のトレーディングカードを取引しよう",
    "introBody1": "BidNova Auctions は、鑑定済みトレーディングカードの売買を行う、信頼できる英国のマーケットプレイスです。主要なあらゆるTCG・スポーツカードカテゴリーのコレクターをサポートし、透明性のある入札、安全なStripe決済、充実した買い手保護を提供します。",
    "weSupportLabel": "対応しているコレクション",
    "introBody2": "PSA、BGS、CGC の鑑定カードをコレクションしている方も、希少な未鑑定カードをお探しの方も、BidNova は買い手保護と信頼できる出品者を備えた安全なマーケットプレイスを提供します。",
    "categoriesEyebrow": "カテゴリーで探す",
    "categoriesTitle": "トレーディングカードのカテゴリー",
    "trustEyebrow": "コレクターがBidNovaを選ぶ理由",
    "trustTitle": "安心して入札できます",
    "trustSecureTitle": "100% 安全な決済",
    "trustSecureBody": "Stripe を採用し、PCI-DSS 完全準拠かつ 3-D セキュアにも対応しています。",
    "trustVerifiedTitle": "認証済み出品者",
    "trustVerifiedBody": "すべての出品で本人確認を実施し、継続的な不正対策を行っています。",
    "trustProtectionTitle": "買い手保護",
    "trustProtectionBody": "透明性のある入札、安全な決済、未着の場合は返金対応。",
    "trustGradingTitle": "プロフェッショナル鑑定",
    "trustGradingBody": "PSA、BGS、CGC、SGC、ACE、PG、TAG の鑑定カードに対応 — PSA、BGS、CGC、SGC は証明書番号を自動照合。",
    "sellerCtaEyebrow": "出品者向け",
    "sellerCtaTitle": "安心してトレーディングカードを出品しよう",
    "sellerCtaBody": "安全な期間限定オークションを通じて、英国全土のコレクターにリーチできます。成約時のみ一律8%の手数料 — 出品料、月額料金、サブスクリプション料金は一切かかりません。リアルタイム入札、安全な入金、出品から配送までの完全な追跡が可能です。",
    "sellerCtaButton": "今すぐ出品を始める",
    "collectionsEyebrow": "対応コレクション",
    "collectionsTitle": "主要なTCG・スポーツカードシリーズをすべて網羅",
    "faqEyebrow": "よくある質問",
    "faqTitle": "よくある質問"
  },
  "faq": {
    "q1": "オンラインのトレーディングカードオークションはどのように行われますか?",
    "a1": "出品者は開始価格、出品期間、任意で即決価格(Buy It Now)を設定してカードを出品します。登録済みの購入者はリアルタイムで入札でき、タイマーが終了すると最高入札者が落札し、Stripe を通じて安全に支払います。その後、出品者が追跡付きでカードを発送し、購入者保護が全過程に適用されます。",
    "q2": "ポケモンカードは出品できますか?",
    "a2": "はい。ポケモンは当社最大のカテゴリーです。未鑑定カードでも、PSA、BGS、CGC、SGC、ACE、PG、TAG による鑑定カードでも出品可能です — 単品でも封入商品でも、ヴィンテージの Base Set から最新の Scarlet & Violet まで対応しています。",
    "q3": "ワンピースカードは出品できますか?",
    "a3": "はい。BidNova はワンピース カードゲームを幅広くサポートしています — Romance Dawn や Paramount War 以降、マンガレア、alt art、鑑定済みスラブも含まれます。",
    "q4": "スポーツカードをオークション出品できますか?",
    "a4": "はい。サッカー、バスケットボール、野球、F1、UFC などのスポーツカードにすべて対応しています — Topps、Panini Prizm、Select、Donruss、Bowman なども含みます。",
    "q5": "どの鑑定会社に対応していますか?",
    "a5": "BidNova は PSA、BGS、CGC、SGC、ACE、PG、TAG による鑑定カードに対応しています。PSA、BGS、CGC、SGC の証明書番号は自動で照合され、ACE、PG、TAG のカードは手動入力で出品できます。",
    "q6": "購入者はどのように保護されますか?",
    "a6": "すべての取引は 3-D セキュア対応の Stripe を通じて処理されます。出品者は本人確認済みで、出品内容は審査されます。購入者は未着・破損・説明と異なる場合に異議申し立てを行うことができ、買い手保護ポリシーに基づき返金を受けられます。",
    "q7": "BidNovaでの出品にかかる費用は?",
    "a7": "BidNova は成約時のみ一律8%の手数料をいただきます。月額料金、サブスクリプション料金、出品料は一切かかりません。"
  },
  "browse": {
    "eyebrow": "マーケットプレイス",
    "defaultH1": "ライブオークション",
    "categoryH1": "{category} カードオークション",
    "defaultIntro": "BidNova Auctions のライブ トレーディングカードオークションをすべて閲覧できます — 鑑定済みのポケモン、ワンピース、遊戯王、ドラゴンボール、Magic: The Gathering、スポーツカードを扱う英国の信頼できるマーケットプレイスです。すべての出品はGBP建てで、Stripeによる安全な決済と買い手保護保証が適用されます。即決価格(Buy It Now)、鑑定会社(PSA、BGS、CGC、ACE)、価格、残り時間で絞り込めるほか、AIスマート検索で探しているものを説明することもできます。",
    "categoryIntro": "BidNova Auctions における {category} トレーディングカードの英国ライブオークションです。GBP建てで、Stripeによる安全な決済と買い手保護保証が適用されます。即決価格(Buy It Now)、鑑定会社(PSA、BGS、CGC、ACE)、価格、残り時間で絞り込めます。",
    "allCategories": "すべてのカテゴリー",
    "marketTrends": "市場トレンド",
    "sellACard": "カードを出品する",
    "smartSearchPlaceholder": "例:「£500以下のPSA 10 リザードン」「日本語版ワンピース マンガレア」",
    "smartSearchButton": "AIスマート検索",
    "smartSearchClear": "クリア",
    "smartSearchAiApplied": "スマート検索を適用しました",
    "smartSearchKeywordApplied": "キーワード検索を適用しました",
    "smartSearchFailed": "スマート検索に失敗しました",
    "purchaseMethodPlaceholder": "購入方法",
    "purchaseAll": "すべての出品",
    "purchaseAuctionOnly": "オークションのみ",
    "purchaseBuyNow": "即決価格あり",
    "purchaseAuctionPlusBin": "オークション + 即決価格",
    "sortPlaceholder": "並び替え",
    "sortEndingSoon": "終了間近",
    "sortNewlyListed": "新着順",
    "sortCurrentBidHigh": "現在の入札額:高い順",
    "sortBinLow": "即決価格:安い順",
    "sortBinHigh": "即決価格:高い順",
    "productTypePlaceholder": "商品タイプ",
    "anyProductType": "すべての商品タイプ",
    "accessoryCategoryPlaceholder": "アクセサリーカテゴリー",
    "anyAccessory": "すべてのアクセサリー",
    "cardTypePlaceholder": "カードタイプ",
    "anyCardType": "すべてのカードタイプ",
    "graderPlaceholder": "鑑定会社",
    "anyGrader": "すべての鑑定会社",
    "gradePlaceholder": "グレード",
    "anyGrade": "すべてのグレード",
    "brandPlaceholder": "ブランド",
    "anyBrand": "すべてのブランド",
    "conditionPlaceholder": "状態",
    "anyCondition": "すべての状態",
    "gamePlaceholder": "対応ゲーム",
    "anyGame": "すべてのゲーム",
    "productLinePlaceholder": "製品ライン / セット",
    "anySetLine": "すべてのセット / ライン",
    "tcgGamePlaceholder": "ゲーム",
    "rarityPlaceholder": "レアリティ",
    "anyRarity": "すべてのレアリティ",
    "languagePlaceholder": "言語",
    "anyLanguage": "すべての言語",
    "finishPlaceholder": "仕上げ",
    "anyFinish": "すべての仕上げ",
    "editionPlaceholder": "エディション",
    "anyEdition": "すべてのエディション",
    "cardSetPlaceholder": "カードセット…",
    "autographedLabel": "サイン入り",
    "serialLabel": "シリアル番号",
    "trustLabel": "信頼性",
    "trustVerifiedChip": "認証済み",
    "trustPartnerChip": "公式パートナー",
    "trustFeaturedChip": "注目ショップ",
    "activeFiltersLabel": "適用中のフィルター:",
    "removeGameFilter": "ゲーム",
    "removeRarityFilter": "レアリティ",
    "removeAutographedFilter": "サイン入り",
    "removeSerialFilter": "シリアル番号",
    "removeVerifiedFilter": "認証済み出品者",
    "removePartnerFilter": "公式パートナー",
    "removeFeaturedFilter": "注目ショップ",
    "removeProductFilter": "商品",
    "removeAccessoryFilter": "アクセサリー",
    "clearAll": "すべてクリア",
    "othersOption": "その他",
    "loadError": "ライブオークションを読み込めませんでした。",
    "noneMatch": "現在の条件に一致するライブオークションはありません。条件を広げるか、しばらくしてから再度ご確認ください。新しい出品は終日随時追加されます。",
    "howBiddingWorksTitle": "入札の仕組み",
    "howBiddingWorksBody": "BidNovaのすべてのオークションは英ポンド（GBP）建てで、開始価格、現在の入札額、終了までのカウントダウンが明確に表示されます。次の有効な入札単位以上で入札でき、他の入札者に上回られた場合は即座に通知が届きます。一部の出品には即決価格（Buy It Now）も用意されています。終了間際に入札があったオークションは自動的に延長され、土壇場での「狙い撃ち」入札を防ぎます。",
    "biddingPoint1": "すべての入札、入札者数、残り時間を確認できる透明な入札。",
    "biddingPoint2": "自動延長機能により、公正な競争を保護。",
    "biddingPoint3": "落札者はStripe経由でカード、Apple Pay、Google Payにより安全に決済。",
    "biddingPoint4": "出品者は追跡付きで発送し、配達確認後に代金が支払われます。",
    "buyerProtectionTitle": "買い手保護と出品者の信頼",
    "buyerProtectionBody": "BidNova Auctionsは英国登録の、GDPRに完全準拠したマーケットプレイスです。決済はStripeにより処理され、商品説明どおりに届いたことを確認するまで保留されます。出品者は本人確認済みで、公開評価を持ち、出品者規約に基づいて運営されており、問題が発生した場合の正式な紛争解決プロセスもあります。",
    "protectionPoint1": "Stripeによる安全なエスクロー方式の決済——配達確認後にのみ資金が解放されます。",
    "protectionPoint2": "公開評価と配送追跡を備えた本人確認済み出品者。",
    "protectionPoint3": "破損・未着・説明相違のカードに対する正式な紛争解決。",
    "protectionPoint4": "英国登録プラットフォーム、英ポンド建て価格、イングランド・ウェールズ法準拠。"
  },
  "seller": {
    "loading": "読み込み中…",
    "loadingListings": "出品を読み込み中…",
    "profileUnavailableTitle": "出品者プロフィールは利用できません",
    "profileUnavailableBody": "この出品者はまだ公開プロフィールを設定していません。",
    "browseAllAuctions": "すべてのオークションを見る",
    "website": "ウェブサイト",
    "noReviewsYet": "レビューはまだありません",
    "reviewCount": "{count, plural, other {(# 件のレビュー)}}",
    "positivePct": "高評価 {pct}%",
    "completedSalesCount": "{count, plural, other {完了した取引 # 件}}",
    "memberSince": "登録日:{date}",
    "statTotalAuctions": "出品総数",
    "statTotalSales": "販売総数",
    "statSuccessfulSales": "成約済み販売",
    "statAverageFeedback": "平均評価",
    "statPositiveFeedback": "高評価率",
    "statVerification": "認証状況",
    "verified": "認証済み",
    "community": "コミュニティ",
    "featuredProducts": "注目の商品",
    "activeAuctions": "進行中のオークション",
    "noActiveListings": "この出品者は現在出品中の商品がありません。",
    "recentlyEnded": "最近終了したオークション",
    "recentReviews": "最新のレビュー",
    "somethingWentWrong": "問題が発生しました",
    "tryAgain": "再試行",
    "notFoundTitle": "出品者が見つかりません",
    "returnHome": "ホームに戻る",
    "loadingReviews": "レビューを読み込み中…",
    "reviewsCouldNotLoad": "レビューを読み込めませんでした。",
    "noReviewsBody": "この出品者にはまだレビューがありません。",
    "loadMoreReviews": "さらにレビューを読み込む",
    "loadingMore": "読み込み中…",
    "anonymousBuyer": "BidNova Auctions の購入者",
    "noWrittenComment": "コメントはありません",
    "reported": "報告済み",
    "signInToReport": "ログインするとこのレビューを報告できます",
    "report": "報告",
    "reportThisReview": "このレビューを報告",
    "reportDialogTitle": "このレビューを報告",
    "reportDialogDescription": "このレビューがどのポリシーに違反しているかをモデレーターにお知らせください。報告は非公開で、BidNova Auctions チームが確認します。",
    "reportReasonLabel": "理由",
    "reportPlaceholder": "例:個人情報が含まれている、スパム、暴言など…",
    "reportTooShort": "最低 {min} 文字必要です",
    "reportLooksGood": "問題ありません",
    "cancel": "キャンセル",
    "submitReport": "報告を送信",
    "reportSubmitted": "報告を送信しました。ご協力ありがとうございます。",
    "reportMinChars": "最低 {min} 文字を入力してください",
    "reportTooLong": "理由が長すぎます",
    "reportSubmitFailed": "報告を送信できませんでした",
    "loadMoreFailed": "レビューをさらに読み込めませんでした"
  },
  "hoverCard": {
    "fallbackName": "出品者",
    "successfulSales": "成約済み販売",
    "positiveFeedback": "高評価率",
    "memberSince": "登録日",
    "rating": "評価",
    "viewProfile": "プロフィールを見る"
  },
  "card": {
    "priceHistory": "価格推移(180日間)",
    "populationReport": "ポピュレーションレポート",
    "catalogEyebrow": "カードカタログ",
    "loading": "読み込み中…",
    "notFound": "カードが見つかりません。"
  },
  "trends": {
    "title": "市場トレンド",
    "subtitle": "BidNova での実際の取引データのみに基づいています。参考情報であり、鑑定評価ではありません。",
    "trendingCards": "トレンドカード",
    "categoryActivity": "カテゴリー別の活動状況",
    "unknownSet": "不明なセット",
    "salesCount": "{count} 件の取引",
    "averagePrefix": "平均 {price}",
    "noTrendData": "この期間のトレンドデータはまだありません。BidNovaでの実際の取引が蓄積されるとトレンドが表示されます。",
    "noActivityData": "この期間の活動データはまだありません。",
    "notFound": "見つかりませんでした。"
  },
  "accessories": {
    "eyebrow": "アクセサリー",
    "breadcrumbHome": "ホーム",
    "breadcrumbAuctions": "オークション",
    "breadcrumbAccessories": "アクセサリー",
    "relatedCategories": "関連するアクセサリーカテゴリー",
    "allAccessories": "すべてのアクセサリー",
    "noListingsBody": "現在出品中の{category}はありません。新しい出品は毎日追加されます — {link}を見るか、しばらくしてから再度ご確認ください。",
    "allAccessoryListings": "すべてのアクセサリー出品",
    "couldNotLoad": "これらの出品を読み込めませんでした。",
    "whyBuyTitle": "BidNovaでアクセサリーを購入する理由",
    "whyBuyBody": "BidNova は英国登録のマーケットプレイスです。すべてのアクセサリーは公開評価を持つ認証済み出品者によって販売され、GBP建てで、Stripeを通じて決済されます。注文が説明どおりに届いたことを確認するまで、代金はお預かりされます。",
    "whyBuyPoint1": "Stripeによる安全な決済と買い手保護。",
    "whyBuyPoint2": "公開評価と紛争解決制度を備えた認証済みの英国出品者。",
    "whyBuyPoint3": "GBP建て表示 — 予期しない為替手数料はありません。",
    "sellingTitle": "アクセサリーを出品しますか?",
    "sellingBody": "承認済みの出品者は、単品カードや封入商品と同じダッシュボードからアクセサリーを出品できます。アクセサリーには鑑定項目は不要です — 写真、状態、開始価格を入力するだけです。",
    "listAnAccessory": "アクセサリーを出品する"
  },
  "auctionDetail": {
    "notFoundTitle": "オークションが見つかりません",
    "notFoundBody": "このURLは正しくないようです — ライブオークションを閲覧してみてください。"
  },
  "sell": {
    "stripeGateTitle": "出品するにはStripeの登録を完了してください",
    "stripeGateBody": "BidNova Auctions は Stripe Connect を通じて出品者に支払います。オークションを公開する前に、入金・出金が有効なStripe Expressアカウントが必要です。設定には数分しかかかりません。",
    "detailsSubmitted": "情報を送信しました",
    "chargesEnabled": "入金が有効です",
    "payoutsEnabled": "出金が有効です",
    "continueOnboarding": "Stripe登録を続ける",
    "startOnboarding": "Stripe登録を開始する",
    "stripeStatusUpdated": "Stripeのステータスを更新しました"
  },
  "cookieConsent": {
    "ariaLabel": "クッキーの同意",
    "heading": "クッキーとプライバシー",
    "body": "サイトの運営（認証、セキュリティ、決済）に必要な厳密に必要なクッキーを使用しています。同意いただいた場合、オークションの改善やオファーのパーソナライズのため、任意の分析用・マーケティング用クッキーも使用します。設定はフッターからいつでも変更できます。",
    "readPolicy": "クッキーポリシーを読む",
    "necessaryTitle": "厳密に必要",
    "necessaryBody": "常時オン——ログイン、セキュリティ、決済に必要です。",
    "analyticsTitle": "分析",
    "analyticsBody": "プラットフォーム改善のための集計利用状況データ。",
    "marketingTitle": "マーケティング",
    "marketingBody": "オファーのパーソナライズとキャンペーン効果の測定。",
    "acceptAll": "すべて同意する",
    "savePreferences": "設定を保存",
    "customise": "カスタマイズ",
    "rejectNonEssential": "任意項目を拒否"
  },
  "stats": {
    "cardsListed": "出品カード数",
    "cardsListedDesc": "開催中および終了したオークションの出品カード総数。",
    "collectors": "コレクター",
    "collectorsDesc": "BidNova で売買している登録コレクター。",
    "auctionVolume": "落札総額",
    "auctionVolumeDesc": "正常に完了したオークションの総取引額。",
    "sellerRating": "出品者評価",
    "sellerRatingDesc": "認証済みバイヤーによる平均評価。",
    "reviewCount": "{count, plural, other {# 件のレビュー}}",
    "newMarketplace": "新しいマーケットプレイス",
    "noRatings": "まだ評価はありません",
    "securePayments": "安全な決済",
    "securePaymentsDesc": "決済は Stripe により安全に処理されます。"
  }
}
